import { InputValidationRules } from 'vuetify';

export type CreateShipmentValidationState = { attempted: boolean };

export function rulesIfAttempted(
  rules: InputValidationRules | undefined,
  attempted: boolean,
): InputValidationRules {
  return attempted && rules ? rules : [];
}
